<template>
    <tr>
        <td class="photo">
            <img :src="pup.photo_small" alt="" />
        </td>
        <td>
            <strong>{{ pup.storeName }}</strong>
            <br />
            {{ pup.suburb }}, {{ pup.province }} <br />
            {{ pup.businessHours }} <br />
        </td>
        <td>
            <input
                :checked="pup.selected"
                :disabled="pup.selected_by_user == true"
                class="secondary"
                type="checkbox"
                @click="selectPuP()"
            />
        </td>
    </tr>
</template>

<script>
export default {
    props: ["pup"],
    name: "pup-item",
    mounted() {
        if (this.pup.selected) {
            this.$emit("change", this.pup);
        }
    },
    methods: {
        selectPuP() {
            var pup = this.pup;
            pup.selected = true;
            this.$emit("change", pup);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../sass/styles/uptown";
.photo {
    width: 101px !important;

    img {
        width: 100px;
        height: 75px;
    }
}
td {
    padding-right: 0px !important;
    padding-top: 5px !important;
    padding-top: 5px !important;
    padding-left: 10px !important;
}
</style>
